import React from "react";
import { t } from "../../i18n";
import { FaMapMarkerAlt, FaPhone, FaClock, FaDirections } from "react-icons/fa";
import "./LocationMap.css";

export default function LocationMap({ location, client, locale = "en" }) {
  const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(location.address)}`;

  return (
    <section className="location-map">
      <div className="container">
        <h2>{t("section.location", locale, { city: location.city })}</h2>
        <div className="lm-grid">
          <div className="lm-info">
            <div className="lm-address">
              <FaMapMarkerAlt className="lm-icon" />
              <div>
                <h3>{location.city}, {location.state}</h3>
                <p>{location.address}</p>
              </div>
            </div>
            <div className="lm-contact">
              <div className="lm-item"><FaPhone className="lm-icon" /><span>{client.phone}</span></div>
              <div className="lm-item"><FaClock className="lm-icon" /><span>{t("map.hoursMF", locale)}</span></div>
            </div>
            <a href={mapsUrl} target="_blank" rel="noopener noreferrer" className="lm-directions-btn">
              <FaDirections /> {t("map.directions", locale)}
            </a>
          </div>
          <div className="lm-map">
            <iframe
              title={`Map of ${location.city} office`}
              src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&q=${encodeURIComponent(location.address)}`}
              width="100%"
              height="300"
              style={{ border: 0, borderRadius: "var(--border-radius-lg)" }}
              allowFullScreen
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
